import { ADMIN_ANNUAL_REPORTING_DASHBOARD_URL, ADMIN_CP_QP_NOMINATION_KEY, ADMIN_CP_QP_NOMINATION_TOOLTIP, ADMIN_CP_QP_NOMINATION_URL, ADMIN_PROGRESS_TRACKER_TOOLTIP, ADMIN_REPORTING_WORKFLOW_KEY, ADMIN_REPORTING_WORKFLOW_TOOLTIP, ADMIN_REPORTING_WORKFLOW_URL, ANNUAL_DECLARATIONS, ANNUAL_DECLARATIONS_KEY, CONSUMER_CP_QP_NOMINATION_KEY, CONSUMER_REPORTING_WORKFLOW_KEY, CP_QP_CP_QP_NOMINATION_KEY, CP_QP_CP_QP_NOMINATION_URL, CP_QP_NOMINATIONS, CP_QP_NOMINATION_TOOLTIP, CP_QP_NOMINATION_URL, CP_QP_ORC_CP_QP_NOMINATION_KEY, CP_QP_ORC_CP_QP_NOMINATION_URL, CP_QP_ORC_REPORTING_WORKFLOW_KEY, CP_QP_ORC_REPORTING_WORKFLOW_URL, CP_QP_REPORTING_WORKFLOW_KEY, CP_QP_REPORTING_WORKFLOW_URL, ENDORSER_CP_QP_NOMINATION_KEY, ENDORSER_CP_QP_NOMINATION_URL, ENDORSER_REPORTING_WORKFLOW_KEY, ENDORSER_REPORTING_WORKFLOW_URL, MANAGE_ASSESTS_URL, MANAGE_ASSETS, MANAGE_ASSETS_KEY, MANAGE_CONFIGURATION, MANAGE_CONFIGURATION_KEY, MANAGE_CONFIGURATION_URL, MANAGE_DOCUMENTS, MANAGE_DOCUMENTS_KEY, MANAGE_DOCUMENTS_URL, MANAGE_REPORTING_LIFECYCLE, MANAGE_REPORTING_LIFECYCLE_KEY, MANAGE_REPORTING_LIFECYCLE_URL, MANAGE_USERS, MANAGE_USERS_KEY, MANAGE_USERS_URL, MANAGE_WORKFLOWS, MANAGE_WORKFLOWS_KEY, MANAGE_WORKFLOWS_URL, ORC_CP_QP_NOMINATION_KEY, ORC_CP_QP_NOMINATION_URL, ORC_REPORTING_WORKFLOW_KEY, ORC_REPORTING_WORKFLOW_URL, PROGRESS_TRACKER_TOOLTIP, REPORTING, REPORTING_KEY, REPORTING_WORKFLOWS, REPORTING_WORKFLOWS_URL, REPORTING_WORKFLOW_TOOLTIP, REPORT_EXPORTS, REPORT_EXPORTS_KEY, REPORT_EXPORTS_URL, SETUP_PREPERATION, SETUP_PREPERATION_KEY, WORKFLOWS, WORKFLOWS_DASHBOARD, WORKFLOWS_DASHBOARD_URL, WORKFLOWS_KEY, WORKFLOW_DASHBOARD_KEY } from './../../shared/constants/constant';

export const ADMIN_MENUS = {
  key: SETUP_PREPERATION_KEY,
  name: SETUP_PREPERATION,
  subMenus: [
    {
      key: MANAGE_USERS_KEY,
      name: MANAGE_USERS,
      iconClass: 'manage-user',
      url: `/${MANAGE_USERS_URL}`,
      tooltip: ''
    },
    {
      key: MANAGE_ASSETS_KEY,
      name: MANAGE_ASSETS,
      iconClass: 'manage-asset',
      url: `/${MANAGE_ASSESTS_URL}`,
      tooltip: ''
    },
    {
      key: MANAGE_REPORTING_LIFECYCLE_KEY,
      name: MANAGE_REPORTING_LIFECYCLE,
      iconClass: 'manage-reporting-cycle',
      url: `/${MANAGE_REPORTING_LIFECYCLE_URL}`,
      tooltip: ''
    },
    {
      key: MANAGE_CONFIGURATION_KEY,
      name: MANAGE_CONFIGURATION,
      iconClass: 'manage-configuration',
      url: `/${MANAGE_CONFIGURATION_URL}`,
      tooltip: ''
    },
    // {
    //   key: MANAGE_WORKFLOWS_KEY,
    //   name: MANAGE_WORKFLOWS,
    //   iconClass: 'fa-clone',
    //   url: `/${MANAGE_WORKFLOWS_URL}`,
    // },
    // {
    //   key: ADMIN_CP_QP_NOMINATION_KEY,
    //   name: CP_QP_NOMINATIONS,
    //   iconClass: 'cp-qp-nomination',
    //   url: `/${ADMIN_CP_QP_NOMINATION_URL}`,
    // },
    // {
    //   key: ADMIN_REPORTING_WORKFLOW_KEY,
    //   name: REPORTING_WORKFLOWS,
    //   iconClass: 'reporting-workflow',
    //   url: `/${ADMIN_REPORTING_WORKFLOW_URL}`,
    // },
  ],
};

export const WORKFLOW_DOCUMENTS_MENUS = {
  key: MANAGE_DOCUMENTS_KEY,
  name: MANAGE_DOCUMENTS,
  subMenus: [
    {
      key: MANAGE_DOCUMENTS_KEY,
      name: MANAGE_DOCUMENTS,
      iconClass: 'report-export',
      url: `/${MANAGE_DOCUMENTS_URL}`,
      tooltip: ''
    }]
}

export const WORKFLOW_USER_MENUS = {
  key: WORKFLOWS_KEY,
  name: WORKFLOWS,
  subMenus: [
    {
      key: MANAGE_WORKFLOWS_KEY,
      name: MANAGE_WORKFLOWS,
      iconClass: 'fa-clone',
      url: `/${MANAGE_WORKFLOWS_URL}`,
      tooltip: ''
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${WORKFLOWS_DASHBOARD_URL}`,
      tooltip: PROGRESS_TRACKER_TOOLTIP
    },
  ],
};

export const WORKFLOW_CP_QP_USER_MENUS = {
  key: WORKFLOWS_KEY,
  name: WORKFLOWS,
  subMenus: [
    {
      key: CP_QP_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      url: `/${CP_QP_CP_QP_NOMINATION_URL}`,
      tooltip: CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: CP_QP_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      url: `/${CP_QP_REPORTING_WORKFLOW_URL}`,
      tooltip: REPORTING_WORKFLOW_TOOLTIP
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${WORKFLOWS_DASHBOARD_URL}`,
      tooltip: PROGRESS_TRACKER_TOOLTIP
    },
  ],
};

export const WORKFLOW_MENUS = {
  key: ANNUAL_DECLARATIONS_KEY,
  name: ANNUAL_DECLARATIONS,
  subMenus: [
    {
      key: ADMIN_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      url: `/${ADMIN_CP_QP_NOMINATION_URL}`,
      tooltip: ADMIN_CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: ADMIN_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      url: `/${ADMIN_REPORTING_WORKFLOW_URL}`,
      tooltip: ADMIN_REPORTING_WORKFLOW_TOOLTIP
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${WORKFLOWS_DASHBOARD_URL}`,
      tooltip: ADMIN_PROGRESS_TRACKER_TOOLTIP
    },
  ],
};

export const CP_QP_ORC_WORKFLOW_MENUS = {
  key: ANNUAL_DECLARATIONS_KEY,
  name: ANNUAL_DECLARATIONS,
  subMenus: [
    {
      key: CP_QP_ORC_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      url: `/${CP_QP_ORC_CP_QP_NOMINATION_URL}`,
      tooltip: CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: CP_QP_ORC_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      url: `/${CP_QP_ORC_REPORTING_WORKFLOW_URL}`,
      tooltip: REPORTING_WORKFLOW_TOOLTIP
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${WORKFLOWS_DASHBOARD_URL}`,
      tooltip: PROGRESS_TRACKER_TOOLTIP
    }
  ],
};

export const ORC_WORKFLOW_MENUS = {
  key: ANNUAL_DECLARATIONS_KEY,
  name: ANNUAL_DECLARATIONS,
  subMenus: [
    {
      key: ORC_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      url: `/${ORC_CP_QP_NOMINATION_URL}`,
      tooltip: CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: ORC_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      url: `/${ORC_REPORTING_WORKFLOW_URL}`,
      tooltip: REPORTING_WORKFLOW_TOOLTIP
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${WORKFLOWS_DASHBOARD_URL}`,
      tooltip: PROGRESS_TRACKER_TOOLTIP
    },
  ],
};

export const ENDORSER_WORKFLOW_MENUS = {
  key: ANNUAL_DECLARATIONS_KEY,
  name: ANNUAL_DECLARATIONS,
  subMenus: [
    {
      key: ENDORSER_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      url: `/${ENDORSER_CP_QP_NOMINATION_URL}`,
      tooltip: CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: ENDORSER_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      url: `/${ENDORSER_REPORTING_WORKFLOW_URL}`,
      tooltip: REPORTING_WORKFLOW_TOOLTIP
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${WORKFLOWS_DASHBOARD_URL}`,
      tooltip: PROGRESS_TRACKER_TOOLTIP
    }
  ],
};

export const CONSUMER_MENUS = {
  key: REPORTING_KEY,
  name: REPORTING,
  subMenus: [
    {
      key: CONSUMER_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      hide: true,
      url: `/${REPORTING_WORKFLOWS_URL}`,
      tooltip: ''
    },
    {
      key: CONSUMER_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      hide: true,
      url: `/${CP_QP_NOMINATION_URL}`,
      tooltip: CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: ADMIN_CP_QP_NOMINATION_KEY,
      name: CP_QP_NOMINATIONS,
      iconClass: 'cp-qp-nomination',
      url: `/${ADMIN_CP_QP_NOMINATION_URL}`,
      tooltip: ADMIN_CP_QP_NOMINATION_TOOLTIP
    },
    {
      key: ADMIN_REPORTING_WORKFLOW_KEY,
      name: REPORTING_WORKFLOWS,
      iconClass: 'reporting-workflow',
      url: `/${ADMIN_REPORTING_WORKFLOW_URL}`,
      tooltip: ADMIN_REPORTING_WORKFLOW_TOOLTIP
    },
    {
      key: WORKFLOW_DASHBOARD_KEY,
      name: WORKFLOWS_DASHBOARD,
      iconClass: 'progress-tracker',
      url: `/${ADMIN_ANNUAL_REPORTING_DASHBOARD_URL}`,
      tooltip: PROGRESS_TRACKER_TOOLTIP
    },
  ],
};


export const REPORTING_EXPORT_MENUS = {
  key: REPORTING_KEY,
  name: REPORTING,
  subMenus: [
    {
      key: REPORT_EXPORTS_KEY,
      name: REPORT_EXPORTS,
      iconClass: 'report-export',
      url: `/${REPORT_EXPORTS_URL}`,
      tooltip: ''
    },
  ],
};
